import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const getCompany = () => client.get("/company").then((r) => r.data);
export const getCategories = () => client.get("/categories").then((r) => r.data);
export const getCategory = (slug) => client.get(`/categories/${slug}`).then((r) => r.data);
export const getProducts = (params) => client.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);
export const getBlog = () => client.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => client.get(`/blog/${slug}`).then((r) => r.data);
export const getStats = () => client.get("/stats").then((r) => r.data);
export const postInquiry = (data) => client.post("/inquiries", data).then((r) => r.data);
export const subscribe = (email) => client.post("/newsletter", { email }).then((r) => r.data);

// Admin (token via X-Admin-Token header)
const adminHeaders = () => ({ headers: { "X-Admin-Token": localStorage.getItem("mg_admin_token") || "" } });
export const adminLogin = (token) => client.post("/admin/login", { token }).then((r) => r.data);
export const adminTargets = () => client.get("/admin/targets", adminHeaders()).then((r) => r.data);
export const adminGetSeo = (kind, slug) => client.get(`/admin/seo/${kind}/${slug}`, adminHeaders()).then((r) => r.data);
export const adminPutSeo = (data) => client.put("/admin/seo", data, adminHeaders()).then((r) => r.data);
export const adminInquiries = () => client.get("/admin/inquiries", adminHeaders()).then((r) => r.data);
export const adminProducts = () => client.get("/admin/products", adminHeaders()).then((r) => r.data);
export const adminGetProduct = (slug) => client.get(`/admin/products/${slug}`, adminHeaders()).then((r) => r.data);
export const adminUpdateProduct = (slug, data) => client.put(`/admin/products/${slug}`, data, adminHeaders()).then((r) => r.data);
export const adminCreateProduct = (data) => client.post("/admin/products", data, adminHeaders()).then((r) => r.data);
export const adminDeleteProduct = (slug) => client.delete(`/admin/products/${slug}`, adminHeaders()).then((r) => r.data);
export const adminDuplicateProduct = (slug) => client.post(`/admin/products/${slug}/duplicate`, {}, adminHeaders()).then((r) => r.data);
export const adminUpload = (file, opts = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  const params = new URLSearchParams();
  if (opts.slug) params.set("slug", opts.slug);
  if (opts.filename_hint) params.set("filename_hint", opts.filename_hint);
  const qs = params.toString() ? `?${params}` : "";
  return client.post(`/admin/upload${qs}`, fd, {
    headers: { ...adminHeaders().headers, "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};

// Buyer portal auth (Emergent-managed Google Sign-In)
export const authExchange = (sessionId) =>
  client.get(`/auth/session?session_id=${encodeURIComponent(sessionId)}`).then((r) => r.data);
export const authMe = () => client.get("/auth/me").then((r) => r.data);
export const authLogout = () => client.post("/auth/logout").then((r) => r.data);
export const portalInquiries = () => client.get("/portal/inquiries").then((r) => r.data);
export const portalReorder = (id) => client.post(`/portal/reorder/${id}`).then((r) => r.data);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/portal";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const COMPANY = {
  name: "Ingren Trading LLP",
  short: "Ingren Trading",
  tagline: "International B2B trading and supply.",
  reg: "Ingren Trading LLP",
  address: "United Kingdom",
  email: "info@ingrentradingllp.com",
  phone: "+44 116 318 0549",
  whatsapp: "441163180549",
};

export const whatsappLink = (text) =>
  `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(text || "Hello Ingren Trading LLP, I would like to enquire about your products and international supply services.")}`;
